import { useAppSelector} from '../data/store';
import YouMayAlsoLikeItem from './you-may-also-like-item';

interface IYouMayAlsoLike {
    addProductHandler: (productId: number) => void;
}

const YouMayAlsoLike = ({ addProductHandler }: IYouMayAlsoLike) => {
    const cartData = useAppSelector(store => store.root.cartData);

    return (
        <>
            {
                cartData?.youMayAlsoLikeData && cartData.youMayAlsoLikeData.length > 0 &&
                <div className="text-gray-700">
                    <p className="font-bold mb-4 mt-10">Frequently bought together</p>
                    <div className="grid grid-cols-1 md:grid-cols-4 gap-x-4 gap-y-2">
                        {
                            cartData.youMayAlsoLikeData.map(item => {
                                return (
                                    <YouMayAlsoLikeItem
                                        key={item.skuid}
                                        item={item}
                                        addProductHandler={addProductHandler}
                                    />
                                )
                            })
                        }
                    </div>
                </div>
            }
        </>
    )
};

export default YouMayAlsoLike;